import PlayerCondensedControls, {
  PlayerCondensedControlsProps,
} from 'components/Player/controls/PlayerCondensedControls';
import { Audiogram } from 'components/Player/visuals';
import {
  ThreeByOneWidgetPlayer,
  ThreeByOneWidgetPlayerProps,
} from 'components/ThreeByOneWidget';
import { ImageResizeStrategy } from 'types';

export interface PlayerProps extends ThreeByOneWidgetPlayerProps {
  artworkAspectRatio?: number;
  artworkResizeStrategy?: ImageResizeStrategy;
  controlsSize?: PlayerCondensedControlsProps['size'];
  className?: string;
}

const Player: React.FC<PlayerProps> = ({
  artworkAspectRatio,
  artworkResizeStrategy,
  controlsSize,
  ...props
}) => (
  <ThreeByOneWidgetPlayer
    controls={<PlayerCondensedControls size={controlsSize} />}
    visualization={
      <Audiogram
        aspectRatio={artworkAspectRatio}
        resize={artworkResizeStrategy}
      />
    }
    {...props}
  />
);

export default Player;
